export default __webpack_public_path__ + "static/media/EAST2500.34I-34657_-19251_0.29c45863.jpg";